'use client';

import { FileText, Star } from 'lucide-react';

type Topic = 'ESTIMATE' | 'REVIEW';

type TopicSelectorProps = {
  onSelect: (topic: Topic) => void;
  isLoading?: boolean;
};

const TOPICS: { id: Topic; icon: React.ReactNode; title: string; description: string }[] = [
  {
    id: 'ESTIMATE',
    icon: <FileText className='h-6 w-6' />,
    title: '견적 문의',
    description: '원하는 시술의 가격과 정보를 알아보세요',
  },
  {
    id: 'REVIEW',
    icon: <Star className='h-6 w-6' />,
    title: '후기 검색',
    description: '시술 후기를 검색하고 비교해보세요',
  },
];

export function TopicSelector({ onSelect, isLoading }: TopicSelectorProps) {
  return (
    <div className='flex h-full flex-col items-center justify-center px-4 py-12'>
      <h2 className='text-foreground mb-2 text-xl font-semibold'>무엇을 도와드릴까요?</h2>
      <p className='text-muted-foreground mb-8 text-center text-sm'>
        문의 유형을 선택해 주세요
      </p>

      <div className='grid w-full max-w-sm gap-3'>
        {TOPICS.map((topic) => (
          <button
            key={topic.id}
            type='button'
            disabled={isLoading}
            onClick={() => onSelect(topic.id)}
            className='border-border bg-card text-foreground hover:bg-accent flex items-center gap-4 rounded-xl border px-5 py-4 text-left transition-all hover:shadow-md disabled:cursor-not-allowed disabled:opacity-50'
          >
            <span className='text-primary shrink-0'>{topic.icon}</span>
            <span>
              <span className='block font-medium'>{topic.title}</span>
              <span className='text-muted-foreground mt-0.5 block text-sm'>{topic.description}</span>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
